import axios from 'axios';
import { SESSION_TOKEN } from '../constants';
import { useFlags } from 'launchdarkly-react-client-sdk';

const contentType = 'application/json';

export const VoeBizApi = () => {
  const ldFlags = useFlags();
  const { apiDomain } = ldFlags;

  return {
    memberInfoReset: async (type: string, value: string, recaptchaToken: string) => {
      const data = { type, value };

      return axios
        .post(`${apiDomain}/members/v1/members/info/reset`, data, {
          headers: {
            'Content-Type': contentType,
            ...(recaptchaToken ? { 'x-recaptcha': recaptchaToken } : undefined),
          },
        })
        .then((response) => {
          return { success: true, response: { data: response.data, smilesToken: response.headers['x-smiles-token'] } };
        })
        .catch((error) => {
          return { success: false, response: error };
        });
    },

    resetPassword: async (smilesToken: string) => {
      return axios
        .get(`${apiDomain}/members/v1/members/password`, {
          headers: {
            'Content-Type': contentType,
            'x-smiles-token': smilesToken,
          },
        })
        .then((response) => {
          return { success: true, response: { data: response.data } };
        })
        .catch((error) => {
          return { success: false, response: error };
        });
    },

    changePasswordNotLogged: async (smilesToken: string, newPassword: string) => {
      const data = {
        newPassword,
      };
      return axios
        .put(`${apiDomain}/members/v1/members/password`, data, {
          headers: {
            'Content-Type': contentType,
            'x-smiles-token': smilesToken,
          },
        })
        .then((response) => {
          return { success: true, response: { data: response.data } };
        })
        .catch((error) => {
          return { success: false, response: error };
        });
    },
    changePassword: async (newPassword: string, currentPassword: string) => {
      const data = {
        newPassword,
        currentPassword,
      };
      const token = localStorage.getItem(SESSION_TOKEN);
      return axios
        .put(`${apiDomain}/members/v1/members/password`, data, {
          headers: {
            'Content-Type': contentType,
            'Authorization': `Bearer ${token}`
          },
        })
        .then((response) => {
          return { success: true, response: { data: response.data } };
        })
        .catch((error) => {
          return { success: false, response: error };
        });
    },
  };
};
